import React from "react";
import {Series} from "remotion";

import {Cover} from "./scenes/Cover";
import {Feature} from "./scenes/Feature";
import {Data} from "./scenes/Data";
import {Ending} from "./scenes/Ending";


export const TechLaunch: React.FC = () => {

  return (

    <Series>

      <Series.Sequence durationInFrames={150}>
        <Cover />
      </Series.Sequence>


      <Series.Sequence durationInFrames={300}>
        <Feature />
      </Series.Sequence>


      <Series.Sequence durationInFrames={300}>
        <Data />
      </Series.Sequence>


      <Series.Sequence durationInFrames={150}>
        <Ending />
      </Series.Sequence>


    </Series>

  );

};
